module.exports = __webpack_public_path__ + "img/icon-medium.a523a2f0.svg";